export default "__VITE_ASSET__NrCp62THtjDpIBT7uPtJXA__"